import typeCheck from 'common/util/typeCheck';

import { SR_API_ACTION_HOUSEHOLD_GET_RENTERS } from 'api/actionTypes';

export default async function loadHouseholdRenters({ state, apiClient }, { userId }) {
  typeCheck('userId::PositiveNumber', userId);
  const householdRentersPath = ['household', 'rentersByUserId', String(userId)];
  if (state.exists(householdRentersPath)) {
    return state.get(householdRentersPath);
  }
  return apiClient.postWithState({
    action: SR_API_ACTION_HOUSEHOLD_GET_RENTERS,
    queryId: String(userId),
    state: state,
    payload: {
      userId,
    },
    onSuccess(householdRenters) {
      state.set(householdRentersPath, householdRenters);
    },
  });
}
